import { relations } from 'drizzle-orm';
import { patientProfiles } from '../models/patientProfiles';
import { users } from '../../user/models/users';

/**
 * @group Patient
 * @summary Patient profile relations for the database schema
 *
 * @remarks
 * Defines the relationships for the patientProfiles table, including the one-to-one
 * relationship with users and the one-to-many relationships with consultations and payment methods.
 *
 * @example
 * ```typescript
 * import { patientProfileRelations } from '@shared/db';
 *
 * // Query patient profile with user details
 * const profileWithUser = await db.query.patientProfiles.findFirst({
 *   where: eq(patientProfiles.id, profileId),
 *   with: {
 *     user: true
 *   }
 * });
 * 
 * // Query user with patient profile
 * const userWithProfile = await db.query.users.findFirst({
 *   where: eq(users.id, userId),
 *   with: {
 *     patientProfile: true
 *   }
 * });
 * ```
 */
export const /**
 * @internal
 */
patientProfileRelations = relations(patientProfiles, ({ one }) => ({
  user: one(users, {
    fields: [patientProfiles.user_id],
    references: [users.id],
  }),
}));
